<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 102 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planType: 102, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
                @successCallBack="planVersionSuccessCallBack"
                @change="(val, list) => planVersionChange(val, list)"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/scp/scpMrpPlans/plannerBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCodeList']"
                selectType="selectMultiple"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 102, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemIdList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="itemCode"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="需求截止日期" :labelCol="{ style: { width: '90px' } }">
              <a-date-picker v-decorator="['newDockDate']" valueFormat="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(form.getFieldsValue())">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '120px' } }">
          <a-row class="align-center">
            <div class="plan-time pt5 pb5">计划运行概况</div>
            <a-col :md="7" :sm="24" class="ml20">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="叫料计算完成时间">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="table-page-operator-wrapper mt5 mb10">
          <download-modal :apiFun="apiScpMrpSuppliesNewExport" ref="download" />
          <a-button @click="handleExport" v-hasPermi="['scp:scpMrpPlanOrganizations:add']">导出</a-button>
          <a-button :disabled="!planVersionNew || selectedRows.length === 0" type="primary" :loadding="fbLoading" @click="handleFb()" v-hasPermi="['scp:scpMrpSupplies:release']">发布</a-button>
          <a-button :disabled="!planVersionNew || tableList.length === 0" :loadding="zbfbLoading" @click="handleZbfb()" v-hasPermi="['scp:scpMrpSupplies:fullVersionRelease']">整版发布</a-button>
        </div>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ x: tableX, fixScreen: true }"
          @successCallBack="successCallBack"
        >
          <span slot="checkboxTitle">
            <a-checkbox :checked="allChecked" @change="allCheckedChange"></a-checkbox>
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record, index }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'checkbox'">
                <a-checkbox v-if="record.id" :checked="record[item.dataIndex]" @change="(e) => { checkedChange(e, index) }"></a-checkbox>
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk" />
        <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpSuppliesList,
  apiScpMrpCategoryCodeCategoryBox,
  apiScpScreeningSchemeSearchAllScheme,
  apiScpMrpPlansCallMaterialPlanExecutionTime,
  apiScpMrpSuppliesRelease,
  apiScpMrpSuppliesNewExport,
  apiScpMrpSuppliesFullVersionRelease,
  apiScpMrpPlansPlanVersionBox
} from '@/api/scp/factoryCallMaterial/partsMaterialPlan'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  name: 'PartsMaterialPlan',
  components: {
    DownloadModal,
    DressingByScreening,
    DressingByScreeningSetUp
  },
  data () {
    return {
      apiScpMrpSuppliesNewExport,
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpSuppliesList, true),
        pageCurrent: true
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2200,
      tableList: [],
      // 表格字段
      columns: [
        {
          // title: '复选框',
          dataIndex: 'checkbox',
          scopedSlots: { customRender: 'checkbox', title: "checkboxTitle" },
          width: 50,
          fixed: 'left'
        },
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 120,
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUom',
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '需求工单号',
          dataIndex: 'demandWipEntityName',
          align: 'center'
        },
        {
          title: '要求到货时间',
          dataIndex: 'newDockDate',
          scopedSlots: { customRender: 'newDockDate' },
          align: 'center',
          type: "text"
        },
        {
          title: '需求量',
          dataIndex: 'newOrderQuantity',
          align: 'center'
        },
        {
          title: '供应组织',
          dataIndex: 'sourceOrganizationName',
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '零部件工单',
          dataIndex: 'wipEntityName',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        }
      ],
      searchList1: [],
      searchList2: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      allChecked: false,
      treeData: [], // 物料类别
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "", // 叫料计算完成时间
      planVersionNew: false, // 是否是最新版本
      fbLoading: false,
      zbfbLoading: false
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.getCategoryIdList(true)
    this.getSearchAllScheme()
  },
  mounted () {},
  methods: {
    // 发布
    handleFb () {
      this.fbLoading = true
      apiScpMrpSuppliesRelease(this.selectedRows).then(response => {
        if (response.code === 200) {
          this.$message.success('发布成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.fbLoading = false
      }).catch(e => {
        this.fbLoading = false
      })
    },
    // 整版发布
    handleZbfb () {
      this.zbfbLoading = true
      apiScpMrpSuppliesFullVersionRelease(this.form.getFieldsValue()).then(response => {
        if (response.code === 200) {
          this.$message.success('整版发布成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.zbfbLoading = false
      }).catch(e => {
        this.zbfbLoading = false
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.getCategoryIdList()
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      const params = this.form.getFieldsValue()
      params.order_type = 'PLANORDER'
      params.status = 'RELEASE'

      this.getTableTime()
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    successCallBack (myDataSource) {
      const tableList = JSON.parse(JSON.stringify(myDataSource))
      tableList.forEach(element => {
        element.checkbox = false
      });
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
      this.allChecked = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.form.setFieldsValue(JSON.parse(val.schemeDetailJson))
      this.getPlanVersion()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.tableList = []
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.form.getFieldsValue()
      params.order_type = 'PLANORDER'
      params.status = 'RELEASE'
      this.$refs.download.openModal(params)
      // this.download('scp/scpMrpSupplies/export', {
      //   ...params
      // }, `零部件叫料计划查询/发布_${new Date().getTime()}.xlsx`)
    },
    // 物料类别
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 计划版本字段-自动填充
    getPlanVersion () {
      apiScpMrpPlansPlanVersionBox({ dataType: 2, planType: 102, planName: this.form.getFieldsValue().planName }).then(res => {
        this.form.setFieldsValue({ planVersion: "" })
        if (res.rows && res.rows.length > 0) {
          res.rows.forEach(element => {
            if (element.bringOutDataOne === "Y") {
              this.form.setFieldsValue({ planVersion: element.realValue })
            }
          });
        }
        this.onSearch()
      })
    },
    // 计划版本下拉框
    planVersionChange (val, list) {
      this.form.setFieldsValue({
        planVersion: val
      })
      if (!list) {
        return false
      }
      this.planVersionSuccessCallBack(list)
    },
    planVersionSuccessCallBack (arr) {
      let flag = false
      arr.forEach(element => {
        if (element.bringOutDataOne === "Y" && element.realValue === this.form.getFieldsValue().planVersion) {
          flag = true
        }
      });
      this.planVersionNew = flag
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.form.setFieldsValue(JSON.parse(element.schemeDetailJson))
              this.getPlanVersion()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    getTableTime () {
      // 数据收集时间、叫料计算完成时间
      apiScpMrpPlansCallMaterialPlanExecutionTime(this.form.getFieldsValue()).then(res => {
        if (res.data) {
          this.dataCollectStartDate = res.data.dataCollectStartDate && this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss') || ""
          this.planCompletionDate = res.data.planCompletionDate && this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss') || ""
        }
      })
    },
    // 全选
    allCheckedChange (e) {
      this.allChecked = e.target.checked;
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      const arr = []
      tableList.forEach(element => {
        element.checkbox = this.allChecked ? this.allChecked : false
        arr.push(element.id)
      });
      this.selectedRowKeys = this.allChecked ? arr : []
      this.selectedRows = this.allChecked ? tableList : []
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
    },
    // 选择
    checkedChange (e, index) {
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      tableList[index].checkbox = e.target.checked

      const arr = []
      const arr2 = []
      tableList.forEach(element => {
        if (element.checkbox) {
          arr.push(element.id)
          arr2.push(element)
        }
      });
      this.selectedRowKeys = arr
      this.selectedRows = arr2
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  font-weight: bold;
}
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
/deep/.ant-calendar-picker {
  width: 100%;
}
</style>
